import { FnSelectModel } from './../fn-select.model';
import {
	Component,
	Input,
	forwardRef,
	ViewEncapsulation,
	ElementRef,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

/**
 * This component is used to create Mulit Select.
 * To use this component import FnSelectModule in Module.
 */
@Component({
	selector: 'fn-multi-select',
	templateUrl: 'fn-multi-select.component.html',
	encapsulation: ViewEncapsulation.None,
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => FnMultiSelectComponent),
			multi: true,
		},
	],
})
export class FnMultiSelectComponent extends FnSelectModel {
	/**
	 * Input  member variable
	 * used to limit the number of items that can be selected in a multi-select .
	 * default value is 0
	 */
	@Input() maxSelectedItems = 0;
	/**
	 * Creates an instance of fn multi select component.
	 */

	@Input() inputKey = '';
	constructor(elementRef: ElementRef) {
		super(elementRef);
	}
}
